import {createApp} from "vue"
import App from './App.vue'
import {Quasar, Notify, Dialog} from 'quasar'
import quasarLang from 'quasar/lang/ru'
import VueEasyLightbox from 'vue-easy-lightbox'
import {VueReCaptcha} from 'vue-recaptcha-v3'
import * as Sentry from "@sentry/vue";
import { VueQueryPlugin } from '@tanstack/vue-query'

import '@quasar/extras/material-icons/material-icons.css'
import 'quasar/src/css/index.sass'
import {createPinia} from "pinia";
import router from "./router"
import { markRaw } from 'vue'

import 'vue-advanced-cropper/dist/style.css';


const pinia = createPinia()

pinia.use(({ store }) => {
    store.router = markRaw(router)
})

const app = createApp(App)
    .use(Quasar, {
        plugins: {
            Notify,
            Dialog
        },
        lang: quasarLang
    })
    .use(VueQueryPlugin)
    .use(pinia)
    .use(VueReCaptcha, {
        siteKey: import.meta.env.VITE_CAPTCHA_KEY,
        loaderOptions: {
            autoHideBadge: true
        }
    })
    .use(VueEasyLightbox);

Sentry.init({
    app,
    dsn: "https://8029eeb21dcc2e5187a6a4d18436f18e@monitoring.greatstack.ru/10",
    integrations: [
        Sentry.browserTracingIntegration({ router }),
        Sentry.replayIntegration(),
        Sentry.captureConsoleIntegration({
            levels: ['error', 'warn', 'log']
        }),
        Sentry.httpClientIntegration()
    ],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for tracing.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,

    // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
    tracePropagationTargets: ["localhost", /^https:\/\/photo\.greatstack\.ru\/api/],

    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
});

app.use(router)
app.mount('#app')
